import script from "./weekSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./weekSchedule.vue?vue&type=script&setup=true&lang=js"

import "./weekSchedule.vue?vue&type=style&index=0&id=446a3d38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-446a3d38"]])

export default __exports__